import { useTranslation } from 'react-i18next';
import { useWidgetState } from '@livechat/widget-react';
import { Typography, Link, Grid } from '@mui/material';
import { LiveChatAgentStatus } from 'utils/consts';
import { IsLoggedIn } from 'utils/user';
import { Icon } from 'components/Icon/';
import { Modal } from 'components/Modal';
import { IModal } from 'components/Modal/Modal';

const ContactUs = (props: IModal) => {
  const { t } = useTranslation();
  const widgetState = useWidgetState();
  const widgetIsAvailable =
    IsLoggedIn() &&
    widgetState &&
    widgetState.availability === LiveChatAgentStatus.online;

  return (
    <Modal {...props}>
      <Grid
        container
        rowSpacing={3}
        sx={{
          width: '264px'
        }}
      >
        <Grid size={12}>
          <Grid
            container
            sx={{
              flexWrap: 'nowrap'
            }}
          >
            <Grid
              size={1}
              sx={{
                paddingTop: '5px',
                marginRight: '13px'
              }}
            >
              <Icon icon="phone" color="success" />
            </Grid>
            <Grid size={11}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 700,
                  marginBottom: 1
                }}
              >
                {t('MODAL_CONTACT_CONTACTUS')}
              </Typography>
              <Link
                href={`tel:${t('COMMON_PHONE_NUMBER').replace(/ /g, '')}`}
                variant="h4"
                sx={{
                  fontWeight: 900
                }}
              >
                {t('COMMON_PHONE_NUMBER')}
              </Link>
              <Typography
                variant="body1"
                sx={{
                  marginTop: 1
                }}
              >
                {t('MODAL_CONTACT_WEEK')}
                <br />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {widgetIsAvailable && (
          <Grid size={12}>
            <Grid
              container
              sx={{
                flexWrap: 'nowrap',
                alignItems: 'center',
                marginBottom: '-10px',
                marginTop: '-2px'
              }}
            >
              <Grid size={1} sx={{ marginRight: '13px', marginTop: '3px' }}>
                <Icon icon="chat" color="success" />
              </Grid>
              <Grid size={11} sx={{ paddingBottom: '6px' }}>
                <Link
                  variant="body1"
                  sx={{
                    fontWeight: 700,
                    lineHeight: '125%',
                    cursor: 'pointer'
                  }}
                  onClick={() => (window as any)?.LC_API?.open_chat_window()}
                >
                  {t('CHAT_CONVERSATION')}
                </Link>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid size={12}>
          <Grid
            container
            sx={{
              flexWrap: 'nowrap',
              alignItems: 'center'
            }}
          >
            <Grid size={1} sx={{ marginRight: '13px' }}>
              <Icon icon="mail" color="success" />
            </Grid>
            <Grid size={11} sx={{ paddingBottom: '6px' }}>
              <Link
                href={`mailto:${t('CONTACT_EMAIL')}`}
                variant="body1"
                sx={{
                  fontWeight: 700,
                  textTransform: 'lowercase',
                  lineHeight: '125%'
                }}
              >
                {t('CONTACT_EMAIL')}
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ContactUs;
